import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ConfirmPopup } from 'primereact/confirmpopup';
import config from '@/config';
import './styles.scss';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Toast } from 'primereact/toast';

const { API_URL } = config;

const CompanySchema = Yup.object().shape({
  name: Yup.string().min(2, 'Занадто коротке!').max(50, 'Занадто довге!').required("Обов'язкове поле"),
});

const ModalCompany = ({ visible, hide, companyData, updateLoad }) => {
  const isEditing = companyData && companyData?._id;
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    setLoading(true);

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_URL}/company`, {
        method: isEditing ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ...values, _id: companyData?._id }),
      });

      if (!response.ok || response.status !== 200) {
        throw new Error('Server error!');
      }

      const data = await response.json();

      if (data?.code === 202) {
        throw new Error(`Компанія уже існує`);
      }

      resetForm();
      hide();
      setLoading(false);
      updateLoad();
    } catch (error) {
      setLoading(false);
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }

    setSubmitting(false);
  };

  return (
    <div className='card flex justify-content-center'>
      <Dialog
        header={isEditing ? 'Редагувати підприємство' : 'Додати підприємство'}
        visible={visible}
        className='dialog-form'
        onHide={hide}
      >
        <Formik
          initialValues={{
            name: companyData?.name ?? '',
          }}
          validationSchema={CompanySchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <Form>
              <div className='m-0 form'>
                <div className='form__elem'>
                  <span className='p-float-label'>
                    <Field name='name' as={InputText} className={errors.name && touched.name ? 'p-invalid' : ''} />
                    <label htmlFor='name'>Назва підриємства</label>
                  </span>
                  {errors.name && touched.name ? (
                    <small id='name-help' className='p-error'>
                      {errors.name}
                    </small>
                  ) : null}
                </div>

                <Button
                  type='submit'
                  loading={loading}
                  className='form__button'
                  label={isEditing ? 'Зберегти' : 'Створити'}
                  icon='pi pi-check'
                />
              </div>
            </Form>
          )}
        </Formik>
      </Dialog>
      <Toast ref={toast} />
    </div>
  );
};

export default ModalCompany;

export const DeleteCompany = ({ visible, open, hide, companyData, updateLoad }) => {
  const toast = useRef(null);
  const buttonEl = useRef(null);

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_URL}/company`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ _id: companyData?._id }),
      });

      if (!response.ok || response.status !== 200) {
        throw new Error('Server error!');
      }

      toast.current.show({ severity: 'info', summary: 'Видалено', detail: 'Компанія успішно видалена.', life: 3000 });
      updateLoad();
    } catch (error) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }
  };

  const accept = () => {
    handleDelete();
  };

  const reject = () => {
    toast.current.show({
      severity: 'warn',
      summary: 'Відміна',
      detail: 'Ви відмінили видалення компанії.',
      life: 3000,
    });
  };
  return (
    <div>
      <Toast ref={toast} />
      <ConfirmPopup
        target={buttonEl.current}
        visible={visible}
        onHide={hide}
        message='Ви дійсно хочете видалити компанію?'
        icon='pi pi-exclamation-triangle'
        accept={accept}
        reject={reject}
        acceptLabel='Так'
        rejectLabel='Ні'
      />
      <Button type='button' ref={buttonEl} icon='pi pi-trash' severity='warning' rounded onClick={open} />
    </div>
  );
};
